/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import { yupResolver } from '@hookform/resolvers/yup';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Paper from '@mui/material/Paper';
import Title from '@mui/material/Typography';
import { FormProvider, useForm } from 'react-hook-form';

import { LoaderButton } from 'components/ProgressButton';
import { styles } from 'routes/renewMember/styles/renewMemberFileCard.styles';
import { useGetRenewInfoCardFile, useRenewWithCardOnFile } from 'hooks';
import { RENEW_CARD_FILE_INIT_VALUES } from 'constants/initial-values';
import { HiddenCreditCardInput, MemberTypeSelect, CardOnFileSelect } from 'components';

import RENEW_MEMBER_FILE_CARD_SCHEMA from './renewMemberFileCard.schema';

const RenewMemberFileCard = ({ setPaymentStatus, renewInfo = {} }) => {
	const [memberTypes, cardsOnFile, memberInstance] = useGetRenewInfoCardFile({ renewInfo });

	const { isLoading, renewWithCardOnFile } = useRenewWithCardOnFile({
		member: memberInstance,
		memberTypes,
		renewInfo,
		setPaymentStatus
	});

	const methods = useForm({
		defaultValues: RENEW_CARD_FILE_INIT_VALUES,
		resolver: yupResolver(RENEW_MEMBER_FILE_CARD_SCHEMA)
	});

	return (
		<Paper elevation={2} sx={styles.card}>
			<CardHeader
				disableTypography
				title={
					<Title component={'span'} variant="h6" color="primary">
						Renew Member with Card on File
					</Title>
				}
			/>

			<CardContent sx={styles.content}>
				<FormProvider {...methods}>
					<form onSubmit={methods.handleSubmit(renewWithCardOnFile)}>
						<HiddenCreditCardInput />

						<MemberTypeSelect memberTypes={memberTypes} />
						<CardOnFileSelect cardsOnFile={cardsOnFile} />

						<LoaderButton
							type="submit"
							variant="contained"
							color="primary"
							circleColor="secondary"
							loading={isLoading}
						>
							Renew with Card on File
						</LoaderButton>
					</form>
				</FormProvider>
			</CardContent>
		</Paper>
	);
};

export default RenewMemberFileCard;
